import "./about.scss";
import { motion } from "framer-motion";

function About() {
  return (
    <div id="about" className="container-About">
      <div className="c container-left">
        <div className="informationA">
          <motion.div
            className="font-face-nh mt-[5vh] ml-[2vw] w-[42vw]"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            transition={{ delay: 0.5, duration: 3.0 }}
            variants={{
              hidden: { opacity: 0, y: 50 },
              visible: { opacity: 1, y: 0 },
            }}
          >
            <h1 className="About font-face-nh">About</h1>
            <h1 className="last-nameA font-face-nh">Me</h1>
            <h2 className="font-body text-white mt-[1vh] md:text-2xl">
              Synopsis: I know stuff and can makes things happen
            </h2>
          </motion.div>
        </div>
      </div>

      <div className="c ">
        <div  className="font-body text-white mt-[3vh] content">
        {/* <motion.div
          className="font-body text-white mt-[3vh] content"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.5 }}
          transition={{ delay: 0.5, duration: 3.0 }}
          variants={{
            hidden: { opacity: 0, z: -100 },
            visible: { opacity: 1, z: 0 },
          }} 
        >
          {/* <p className="p-3 mr-[5vw] md:max-lg:text-2xl in"></p> */}
          <p className="p-3 mr-[5vw] md:max-lg:text-base in">
            {/* I am a Shreyas aka Trace, self-taught web developer with a strong
            background in both front-end and back-end technologies. <br />I
            specialize in creating dynamic and responsive web designs using
            HTML, CSS, and JavaScript, and I have a deep understanding of React
            for building user interfaces.
            <br />
            On the back-end, I am proficient in Node.js, MongoDB, Express, and
            Sanity, allowing me to build efficient and scalable web
            applications.
            <br />I am constantly learning and expanding my skillset to stay
            up-to-date with the latest web development trends and technologies.
            With my strong problem-solving abilities and attention to detail, I
            can turn complex ideas into reality and deliver high-quality results
            to my clients. */}
            Hi there, I'm Shreyas, aka Trace - a web developer with a passion
            for creating visually stunning and dynamic web experiences. I
            specialize in both front-end and back-end technologies, using my
            mastery of HTML, CSS, and JavaScript to craft seamless user
            interfaces that engage and captivate audiences.
            <br />
            <br />
            By harnessing the power of React, coupled with cutting-edge
            frameworks such as Gatsby and NextJs, I am able to create designs that are both
            formidable and intuitive, resonating deeply with all who interact
            with them. Behind the scenes, I wield a formidable array of tools,
            including Node.js, MongoDB, Express, Sanity, and various BaaS
            technologies, which allow me to build applications that are both
            highly efficient and easily scalable. Whether in the front-end or
            back-end, my deep knowledge and expertise allow me to push the
            boundaries of what is possible in web development, delivering
            world-class solutions that are tailored to meet the unique needs of
            each and every client.
            <br /> <br />
            My drive for lifelong learning helps me stay on top of the latest
            trends and technologies, ensuring that I can bring even the most
            complex ideas to fruition. My problem-solving abilities and
            attention to detail allow me to create top-quality work.
            <br />  <br />
            Thank you for taking the time to learn a bit about me. I am excited
            to work together and create something amazing!
          </p>
          </div>
        {/* </motion.div> */}
      </div>
    </div>
  );
}

export default About;
